import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';

const MarketingTabContent = () => {
	const intl = useIntl();

	const gwp9473JSWAnchorUpdates = checkFeatureFlagGate(featureFlags.gwp9473JSWAnchorUpdates);

	const marketingHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.marketing.header',
			defaultMessage: 'Unleash the power of marketing teams with Jira',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/62xi2h6p73mrb7t2ib163ss3qeh22c5f.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.marketing.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira board tracking a marketing launch',
			}),
		},
	};

	const gwp9473JSWAnchorUpdatesHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.marketing.header',
			defaultMessage: 'Go from big idea to an even bigger launch',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ox58yay38c0ps0rm5xeg0e2765128to3.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.marketing.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira list view',
			}),
		},
	};

	return (
		<PaidHeroTabPanelTemplate
			{...(gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : marketingHeroProps)}
		/>
	);
};

export default MarketingTabContent;
